var _path, _path2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgExclusiveProgramIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 150,
    height: 150,
    viewBox: "0 0 150 150",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M68.6387 7.65444C72.5751 5.38176 77.4249 5.38176 81.3613 7.65444L130.142 35.8181C134.079 38.0908 136.504 42.2909 136.504 46.8363V103.164C136.504 107.709 134.079 111.909 130.142 114.182L81.3613 142.346C77.4249 144.618 72.5751 144.618 68.6387 142.346L19.8577 114.182C15.9213 111.909 13.4964 107.709 13.4964 103.164V46.8363C13.4964 42.2909 15.9213 38.0908 19.8577 35.8181L68.6387 7.65444Z",
    fill: "url(#paint0_linear_573_26547)",
    stroke: "url(#paint1_linear_573_26547)",
    strokeWidth: 6.89655
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M72.0805 98.2759L60.3447 77.8035V72.9788H64.2566C65.8214 72.9788 67.1906 72.7615 68.3641 72.3269C69.5812 71.8487 70.5809 71.175 71.3633 70.3057C72.1891 69.4364 72.7542 68.3932 73.0584 67.1762H60.3447V62.3515H72.9932C72.7324 61.2214 72.2761 60.2217 71.6241 59.3524C71.0155 58.483 70.1897 57.8093 69.1465 57.3312C68.1468 56.8096 66.9298 56.5488 65.4954 56.5488H60.3447V51.7241H89.7492V56.5488H79.5131C80.252 57.3747 80.8605 58.2657 81.3386 59.222C81.8602 60.1782 82.208 61.2214 82.3818 62.3515H89.7492V67.1762H82.5122C82.0776 70.3926 80.8388 72.9136 78.7959 74.7392C76.753 76.5213 74.1233 77.7383 70.9069 78.3903L83.6858 98.2759H72.0805Z",
    fill: "url(#paint2_linear_573_26547)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_573_26547",
    x1: 75.0002,
    y1: -3.22716,
    x2: 75.0002,
    y2: 153.227,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#11101F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D4978"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_573_26547",
    x1: 18.75,
    y1: 31.25,
    x2: 106.25,
    y2: 121.875,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B85CC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBADF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_573_26547",
    x1: 64.0203,
    y1: 61.4224,
    x2: 88.917,
    y2: 77.7101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7D78C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BDBADF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExclusiveProgramIcon);
export default __webpack_public_path__ + "static/media/exclusiveProgramIcon.9ba21179b979b5bf608783744051fc5a.svg";
export { ForwardRef as ReactComponent };